import { useLanguage } from "../../Translations/LenguageContext";
import Spinner from "../../Components/Spinner";
import ErrorMessage from "../../Components/ErrorMessage";
import { useEffect, useState } from "react";
import { PiMagnifyingGlass } from "react-icons/pi";
import { useNavigate } from "react-router-dom";
import FormatDateTime from "../../Functions/FormatDate";
import { MdOutlineChecklist } from "react-icons/md";
import { TbInfoSquare } from "react-icons/tb";
import ContextsLoader from "../../Loaders/ContextsLoader";

const GEN_BACKEND_LINK = process.env.REACT_APP_GEN_BACKEND_LINK;

const GeoProperty = ({
    account_id,
    org_id,
    geo_id,
    selectedPropertyId,
    setSelectedPropertyId,
    savePropertyGeo,
    loadingSave,
    setErrorMessage,
    errorMessage
}) => {
    const { t } = useLanguage();
    const navigate = useNavigate()
    const [loadingProperties, setLoadingProperties] = useState(false);
    const [data, setData] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");

    const fetchPropData = async () => {
        setLoadingProperties(true);

        try {
            const response = await fetch(
                `${GEN_BACKEND_LINK}/get_properties`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        account_id,
                        org_id
                    }),
                }
            );

            const result = await response.json();

            if (!response.ok) {
                throw new Error(result.error || "Failed to fetch");
            }

            setData(result.data);
        } catch (err) {
            console.error("Error fetching GEO optimization:", err);
        } finally {
            setLoadingProperties(false);
        }
    };

    const navigateNewProp = () => {
        navigate(`/console/organizations/${org_id}/properties`);
    };

    const filteredProperties = data.filter((data) => {
        const search = searchTerm.toLowerCase().trim();

        if (!search) return true;

        return (
            String(data.id ?? "").toLowerCase().includes(search) ||
            String(data.name ?? "").toLowerCase().includes(search) ||
            String(data.domain ?? "").toLowerCase().includes(search) ||
            String(data.base_url ?? "").toLowerCase().includes(search) ||
            String(data.created_at ?? "").toLowerCase().includes(search) ||
            String(FormatDateTime(data.created_at) ?? "")
                .toLowerCase()
                .includes(search)
        );
    });

    const selectedPropertyWithoutSources = data.filter(
        (data) =>
            selectedPropertyId.includes(data.id) &&
            data.tag_status != "DETECTED"
    );

    useEffect(() => {
        if (account_id && org_id && geo_id) {
            fetchPropData();
        }
    }, [account_id, org_id, geo_id]);


    return (
        <div className="geo_context_cont">
            <p className="add_new_source_cont_title fade-in">
                {t.geo.add_property_geo}
            </p>

            <p className="add_new_source_cont_desc fade-in">
                {t.geo.add_property_geo_desc}
            </p>

            {/* <div className="language_cont">
                <div className="source_website_input_cont">
                    <div className="source_website_input">
                        <p className="source_website_input_prefix">
                            https://
                        </p>

                        <input
                            className="source_website_main_inputs"
                            type="text"
                            value={selectedUrl || ""}
                            onChange={handleUrlChange}
                            onKeyDown={handleUrlKeyDown}
                            placeholder="example.com"
                            disabled={loadingValidate}
                        />
                    </div>

                    <button
                        type="button"
                        className="source_website_btn"
                        onClick={validateUrl}
                        disabled={loadingValidate || !selectedUrl?.trim()}
                    >
                        {loadingValidate ? (
                            <Spinner loading={loadingValidate} />
                        ) : (
                            <PiMagnifyingGlass />
                        )}
                    </button>
                </div>
            </div> */}

            {loadingProperties ? (
                <ContextsLoader />
            ) : (
                data.length > 0 ? (
                    <div className="geo_context_choise_container">
                        <div className="geo_context_search_container fade-in">
                            <input
                                className="geo_context_search_input"
                                placeholder={t.geo.geo__prop_filter_placeholder}
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                            />
                            <i>
                                <PiMagnifyingGlass />
                            </i>
                        </div>

                        <div className="geo_context_choise_cont">
                            {filteredProperties.length > 0 ? (
                                <div className="geo_context_choise_cont_container">
                                    <div className="geo_context_choise_cont_header">
                                        <p>
                                            {filteredProperties.length}{" "}
                                            {filteredProperties.length > 1
                                                ? t.geo.items
                                                : t.geo.item}
                                        </p>
                                    </div>

                                    <div className="geo_context_choise_cont_body">
                                        {filteredProperties.map((data) => {
                                            const isSelected =
                                                selectedPropertyId.includes(data.id);

                                            const hasNoSources =
                                                data.tag_status != "DETECTED";


                                            return (
                                                <div
                                                    className={`geo_context_choise fade-in ${isSelected
                                                        ? "geo_context_choise_selected"
                                                        : ""
                                                        }`}
                                                    key={data.id}
                                                    onClick={() =>
                                                        setSelectedPropertyId(data.id)
                                                    }
                                                    role="button"
                                                    tabIndex={0}
                                                    aria-pressed={isSelected}
                                                >
                                                    <p>
                                                        <i>
                                                            <TbInfoSquare />
                                                        </i>

                                                        {data.name}

                                                        {hasNoSources ? (
                                                            <span className="source_count no_sources">
                                                                {t.properties.not_installed}
                                                            </span>
                                                        ) : (
                                                            <span className="source_count">
                                                                {t.properties.connected_status}
                                                            </span>
                                                        )}
                                                    </p>

                                                    <span>
                                                        {FormatDateTime(
                                                            data.created_at
                                                        )}
                                                    </span>
                                                </div>
                                            );
                                        })}
                                    </div>
                                    {selectedPropertyWithoutSources.length > 0 && (
                                        <p className="selected_contexts_warning fade-in" dangerouslySetInnerHTML={{ __html: t.properties.not_installed_status_desc_geo }}>
                                        </p>
                                    )}
                                </div>
                            ) : (
                                <div className="organizations_cont_no_items_mex fade-in">
                                    <p>{t.no_data_found_by_search}</p>
                                </div>
                            )}
                        </div>

                        <p className="warning_source_message fade-in">
                            {t.geo.need_property}
                            <button
                                type="button"
                                className="create_new_cntx_btn"
                                onClick={navigateNewProp}
                            >
                                {t.geo.click_here}
                            </button>
                        </p>
                        <p className="warning_source_message fade-in">
                            {t.geo.add_property_geo_warning}
                        </p>

                        <div className="modal_footer_err_cont">
                            <ErrorMessage err={errorMessage} />
                        </div>

                        <div className="open_frame_body_footer">

                            {(selectedPropertyId) && (
                                <button
                                    type="button"
                                    className="modale_save_btn fade-in"
                                    onClick={savePropertyGeo}
                                >
                                    {loadingSave ? (
                                        <Spinner loading={loadingSave} />
                                    ) : (
                                        <>
                                            {t.next}
                                            <i className="fa-solid fa-chevron-right"></i>
                                        </>
                                    )}
                                </button>
                            )}
                        </div>
                    </div>
                ) : (
                    <div className="geo_context_choise_container">
                        <div className="organizations_cont_no_items_mex fade-in">
                            <p>{t.no_data_found}</p>
                        </div>
                        <p className="warning_source_message fade-in">
                            {t.geo.need_property}
                            <button
                                type="button"
                                className="create_new_cntx_btn"
                                onClick={navigateNewProp}
                            >
                                {t.geo.click_here}
                            </button>
                        </p>
                        <p className="warning_source_message fade-in">
                            {t.geo.add_property_geo_warning}
                        </p>
                    </div>
                )
            )}
        </div>
    );
};

export default GeoProperty;